module.exports = __webpack_public_path__ + "img/025.74db9f94.png";